import { initMobilePartnersToggle } from "../partners/mobile-toggle";
import { initFaqDefaultToggle } from "./faq-default-toggle";
import "../bootstrap-init";

let submitingContactForm = false;
let filesUpload = [];
let recaptchaToken = null;

window.captchaValidated = function (token) {
  recaptchaToken = token;
  const btn = document.getElementById("btnFormContact");
  if (btn) {
    btn.removeAttribute("disabled");
    btn.classList.remove("disable");
    btn.setAttribute("type", "submit");
  }
};

function changeDocumentFieldMaskListener() {
  const document = $("#cpfcnpj");
  document.keyup(() => {
    const hasLetter = /[a-zA-Z]/.test(document.val())

    if (!hasLetter && document.val().length <= 14) {
      document.mask("AAA.AAA.AAA-AAA");
    } else {
      document.mask("AA.AAA.AAA/AAAA-00");
    }
  });
}

function formatFileNameToFront(name, extension) {
  return name.length > 20 ? name.substring(0, 10) + "... ." + extension : name;
}

function replaceNameToClass(name) {
  return name.replaceAll(" ", "-").toLowerCase().replaceAll(".", "--");
}

function appendDivFile(file_name, file_size, file_type) {
  const extensions = {
    "application/pdf": "pdf",
    "text/csv": "csv",
    "text/plain": "txt",
    "image/png": "img",
    "image/jpg": "img",
    "image/jpeg": "img",
    "image/bitmap": "img",
    "image/svg+xml": "img",
  };

  const fileIcon = extensions[file_type] ? extensions[file_type] : false;

  if (!fileIcon) {
    appendHelpModalForm(
      "Opss",
      "Extensão de arquivo não permitido",
      "/static/images/icons/alert.png"
    );
    return;
  }

  $("#files_uploaded").append(
    `<div class="file ${replaceNameToClass(file_name)}">
      <img src="/static/images/icons/files/${fileIcon}.svg"/>
      <div class="info">
        <span class="filename">${formatFileNameToFront(
      file_name,
      extensions[file_type]
    )}</span><br>
        <span class="size">${humanFileSize(file_size, true)}</span>
      </div>
      <btn class="remove-btn" onclick="(function() {
        $('.${replaceNameToClass(file_name)}')[0].remove();
        $('.max-files-uploaded').css('display', 'none');
      })()" >x</btn></div>
    `
  );
}

function humanFileSize(bytes, si) {
  let thresh = si ? 1000 : 1024;
  if (Math.abs(bytes) < thresh) {
    return bytes + " B";
  }
  var units = si
    ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
    : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
  var u = -1;
  do {
    bytes /= thresh;
    ++u;
  } while (Math.abs(bytes) >= thresh && u < units.length - 1);
  return bytes.toFixed(1) + " " + units[u];
}

function verifyFormImages(imagesWillBeUploaded, insertedImages) {
  if (imagesWillBeUploaded > 5 || insertedImages + imagesWillBeUploaded > 5) {
    appendHelpModalForm(
      "Opss",
      "Você pode enviar no máximo 5 arquivos",
      "/static/images/icons/alert.png"
    );
    throw new Error("Você pode enviar no máximo 5 arquivos");
  }
}

function createUploadFileListeter() {
  $("#box_file").on("change", (e) => {
    const files = e.target.files;
    verifyFormImages(files.length, $("#files_uploaded")[0].childElementCount);
    if (files && files.length) {
      e.preventDefault();
      e.stopPropagation();
      for (let file of files) {
        filesUpload.push(file);
        appendDivFile(file.name, file.size, file.type);
      }
    }
  });
}

function createContactSubmitListener() {
  $("#contact-form").on("submit", (e) => {
    e.preventDefault();
    submitContactForm(e);
  });
}

async function submitContactForm(event) {
  $('#contact-form').validate()
  const isValid = $('#contact-form').valid()
  if (!isValid) {
    return
  }
  $("#btnFormContact").text("Enviando...");

  if (submitingContactForm) return;

  submitingContactForm = true;
  $("#btnFormContact").attr("disabled", true);

  var form = $("#contact-form");
  var dataArray = form.serializeArray();
  var data = {};
  for (let i = 0; i < dataArray.length; i++) {
    data[dataArray[i].name] = dataArray[i].value;
  }

  var payload = {
    document: data.document,
    name: data.name,
    email: data.email,
    subject: `[QJ] ${data.body}`,
  };

  try {
    result = await $.ajax({
      url: "/ticket",
      type: "POST",
      data: JSON.stringify({
        payload: payload,
        recaptcha_token: recaptchaToken,
      }),
      dataType: "json",
      contentType: "application/json",
      error: (xhr, resp, text) => {
        appendHelpModalForm(
          "Inválido",
          "Não conseguimos enviar a sua mensagem.",
          "/static/images/icons/alert.png"
        );
        $("#btnFormContact").text("Enviar");
        submitingContactForm = false;
        $('#contact-form').each(function () {
          this.reset();
        });
      },

    });
  } catch (e) {
    console.error(e)
  }
  $('#contact-form').each(function () {
    this.reset();
  });
  $("#btnFormContact").addClass("disable");

  for (let file of filesUpload) {
    const formData = new FormData();
    formData.append("uploaded_data", file);
    await $.ajax({
      url: "/ticket/" + result.id + "/upload",
      type: "POST",
      data: formData,
      processData: false,
      contentType: false,
      error: (xhr, resp, text) => {
        appendHelpModalForm(
          "Inválido",
          "Não conseguimos enviar seu arquivo.",
          "/static/images/icons/alert.png"
        );
        $("#btnFormContact").text("Enviar");
        submitingContactForm = false;
      },
    });
  }
  appendHelpModalForm(
    "Recebemos a sua mensagem.",
    "Recebemos a sua mensagem e em breve entraremos em contato com você.",
    "/static/images/icons/success.png"
  );

  $("#btnFormContact").text("Enviar");
  $("#contact-form")[0].reset();
  $("#files_uploaded").empty();
  ga("send", "event", "Form", "submit", "/form/contact");

  grecaptcha.reset();
  recaptchaToken = null;
  submitingContactForm = false;
}

function appendHelpModalForm(title, msg, img) {
  $("#form-help-message").text(msg);
  $("#modalTitle").text(title);
  $("#image-help-modal").attr("src", img);
  $("#exampleModal").modal("toggle");
}

function closeHelpFormModal() {
  $("#exampleModal").removeClass("show").css("display", "none");
}

changeDocumentFieldMaskListener();
createUploadFileListeter();
createContactSubmitListener();
initMobilePartnersToggle();
initFaqDefaultToggle();
